// src/context/SocketContext.js

import React, { createContext, useContext, useEffect, useState } from "react";

import { io } from "socket.io-client";

const SocketContext = createContext(null);

export const useSocket = () => {
  return useContext(SocketContext);
};

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    const BASE_URL = process.env.REACT_APP_BASE_URL;

    const token = localStorage.getItem("ntk");
    const userId = localStorage.getItem("userId");

    if (!BASE_URL) {
      console.error("❌ REACT_APP_BASE_URL missing");
      return;
    }

    console.log("==============================");
    console.log("Connecting Wally Socket");
    console.log("URL:", BASE_URL);
    console.log("USER:", userId);
    console.log("==============================");

    const socketInstance = io(BASE_URL, {
      path: "/socket.io",

      transports: ["polling", "websocket"],

      upgrade: true,

      autoConnect: true,

      reconnection: true,

      reconnectionAttempts: Infinity,

      reconnectionDelay: 2000,

      reconnectionDelayMax: 5000,

      timeout: 10000,
      query: {
        userId: userId,
        role: "admin", // "customer" | "vendor" | "delivery"
      },
      auth: {
        // Backend:
        // socket.handshake.auth.token

        token: token || null,
      },
    });

    // ===============================
    // CONNECT
    // ===============================

    socketInstance.on("connect", () => {
      console.log("✅ Socket Connected");

      console.log("Socket ID:", socketInstance.id);

      /*
          Optional backend event
        */

      if (token) {
        socketInstance.emit("connection", {
          token,
        });
      }

      /*
          User online status
        */

      if (userId) {
        socketInstance.emit("user_online", {
          userId,
        });
      }

      /*
          Admin inbox room

          Backend:
          join_chat("agent")

          Room:
          user_inbox_agent
        */

      socketInstance.emit("join_chat", "agent");
    });

    // ===============================
    // DISCONNECT
    // ===============================

    socketInstance.on("disconnect", (reason) => {
      console.log("❌ Socket disconnected", reason);
    });

    // ===============================
    // CONNECTION ERROR
    // ===============================

    socketInstance.on("connect_error", (error) => {
      console.log("❌ Socket Connection Error");

      console.log("Message:", error.message);

      console.log("Description:", error.description);

      console.log("Context:", error.context);
    });

    // ===============================
    // SOCKET ERROR
    // ===============================

    socketInstance.on("error", (error) => {
      console.log("❌ Socket Error", error);
    });

    // ===============================
    // DEBUG ALL EVENTS
    // Remove in production
    // ===============================

    socketInstance.onAny((event, ...args) => {
      console.log("📩 SOCKET EVENT:", event, args);
    });

    setSocket(socketInstance);

    // ===============================
    // CLEANUP
    // ===============================

    return () => {
      console.log("Disconnecting socket...");

      /*
        Leave admin inbox
      */

      socketInstance.emit("leave_chat", "agent");

      socketInstance.removeAllListeners();

      socketInstance.disconnect();
    };
  }, []);

  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
};

export default SocketContext;
